/**
 * ## Loading screen
 *
 * @module controllers/loading
 */

"use strict";

const conf = require("../../config");
const func = require("../../controllers/func");

let delay = 1000;
let reveal = 0.5;

const complete = (kd) => {
  if (conf.vars.NODE_ENV === "development" || kd.usage === "embed") {
    block();
    $("#layout_main").css("display", "block");
  } else {
    if (func.isMobile()) {
      delay = 1500;
      reveal = 0;
    }
    setTimeout(() => {
      $("#layout_main").css("display", "block");
      if (func.isMobile()) {
        block();
      } else {
        TweenMax.to("#loading", reveal, {
          alpha: 0,
          ease: Power2.easeOut,
          onComplete: block,
        });
      }
    }, delay);
  }
};

const start = () => {
  TweenMax.to("#loading", 0, {
    height: $(window).height(),
  });
};

const resume = () => {
  $("#loading").css("display", "block");
  TweenMax.to("#loading", reveal, {
    height: $(window).height(),
    ease: Power2.easeOut,
  });
};

const block = () => {
  $("#loading").css("display", "none");
  $("#loading").remove();
};

module.exports = {
  complete,
  start,
  resume,
  block,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/loading/index.js
 **/